import React from 'react';
import Files from 'react-files';
import AssetList from './AssetList';
import { LucideIcon as Icon, List, Text } from '../../../../../../ui-kit';
import { UploadCloud } from 'lucide-react';
import { notify } from '../../../../../Notifications';
import '../styles/_voice-over-v2.scss';















const UploadVoiceOver = (props) => {
  const {
    handleCustomAssets,
    customAssets,
    getAssets,
    handleChangeCustomAssetDescription,
    fileRef,
    handleDeleteCustomAssets,
    handleOpenAssetDetailsModal,
    organisationId,
    handleRemoveAssetFromProject,
    canUpdateVideo,
    assetsMap
  } = props;

  const renderAssetList = (asset) =>
  <AssetList
    assetId={asset.assetId}
    getAssets={getAssets}
    assetsMap={assetsMap}
    organisationId={organisationId}
    handleDeleteCustomAssets={handleDeleteCustomAssets}
    handleOpenAssetDetailsModal={handleOpenAssetDetailsModal}
    handleRemoveAssetFromProject={handleRemoveAssetFromProject}
    canUpdateVideo={canUpdateVideo} />;



  const renderBottomAssetList = (asset) =>
  <AssetList
    assetId={asset.assetId}
    description={asset.description}
    getAssets={getAssets}
    organisationId={organisationId}
    handleChangeCustomAssetDescription={handleChangeCustomAssetDescription}
    isDescriptionForm
    handleRemoveAssetFromProject={handleRemoveAssetFromProject}
    canUpdateVideo={canUpdateVideo} />;



  function addFileRef(element) {
    if (element && !fileRef.current.includes(element)) {
      fileRef.current.push(element);
    }
  }

  const onFilesError = (error) => {
    notify({
      title: 'Invalid File Type',
      content: `${error.message}`,
      type: 'error'
    });
  };

  return (
    <div>
      <Files
        onChange={handleCustomAssets}
        accepts={['audio/*', 'video/*']}
        multiple
        onError={onFilesError}
        maxFileSize={524288000}
        minFileSize={0}
        ref={addFileRef}
        clickable={canUpdateVideo}>

        {customAssets && !customAssets.length &&
        <div className="voice-over-v2--custom-asset-upload">
            <Icon icon={UploadCloud} color="regent" size={24} />
            <div className="voice-over-v2--custom-asset-upload__info">
              <div className="voice-over-v2--custom-asset-upload__info--title">
                Upload your own voice over audio file
              </div>
              <div className="voice-over-v2--custom-asset-upload__info--subtitle">
                or drag and drop here
              </div>
            </div>
          </div>}

        {customAssets && customAssets.length > 0 &&
        <div className="voice-over__upload-section--attachments">
            <List
            data={customAssets}
            renderCardItem={renderAssetList}
            hideSearchFilter
            hideFilters />

          </div>}

      </Files>
      {customAssets && customAssets.length > 0 &&
      <>
          <hr />
          <div className="voice-over-v2--custom-assets-list">
            <Text body highlighted>My Voice Artists</Text>
            <List
            data={customAssets}
            renderListItem={renderBottomAssetList}
            hideSearchFilter
            hideFilters />

          </div>
        </>}

    </div>);

};

export default UploadVoiceOver;